import React, {forwardRef} from 'react';
import {NoteLinkView} from './Note.styles';
import type {LinkProps} from '../Link';

export type NoteLinkProps = LinkProps;

export const NoteLink = forwardRef<HTMLAnchorElement, NoteLinkProps>(
  ({children, ...props}: NoteLinkProps, ref) => {
    return (
      <NoteLinkView {...props} ref={ref}>
        {children}
      </NoteLinkView>
    );
  }
);

NoteLink.displayName = 'NoteLink';
NoteLink.toString = NoteLinkView.toString;

export default NoteLink;
